import { AnswerMode } from './AnswerMode';

/**
 * Class representing a happy-sad answer mode.
 * @extends AnswerMode
 */
export class HappySadAnswerMode extends AnswerMode {}
